import {
  getTransportadorasCErros,
  qtdTotal,
  propsArquivos,
  propsOcorrencias,
  getDataForList,
} from "../slices/utils";
import constants from "@tracking/utils/constants";
import moment from "moment";

const { DATETIME_FORMAT } = constants;

export const ediReducer = (state: any, action: { payload: any }) => {
  const { nestedList } = action.payload;

  const props =
    state.ediGeralFilters.tabAtual === "arquivos"
      ? { arrProps: [...propsArquivos], propErrName: "ArquivosErro" }
      : { arrProps: [...propsOcorrencias], propErrName: "OcorrenciasErro" };

  state.dataEdi[state.ediGeralFilters.tabAtual] = {
    total: {
      defaultData: qtdTotal(nestedList, ...propsOcorrencias, "Total"),
      comErros: getTransportadorasCErros(
        nestedList,
        props.propErrName,
        "Total"
      ),
    },
    entrega: {
      defaultData: qtdTotal(nestedList, ...propsOcorrencias, "Entrega"),
      comErros: getTransportadorasCErros(
        nestedList,
        props.propErrName,
        "Entrega"
      ),
    },
    reversa: {
      defaultData: qtdTotal(nestedList, ...propsOcorrencias, "Reversa"),
      comErros: getTransportadorasCErros(
        nestedList,
        props.propErrName,
        "Reversa"
      ),
    },
    comprovantes: {
      defaultData: qtdTotal(nestedList, "Comprovantes"),
      comErros: [],
    },
    MP: {
      defaultData: qtdTotal(nestedList, ...propsOcorrencias, "CB Entrega"),
      comErros: getTransportadorasCErros(
        nestedList,
        props.propErrName,
        "CB Entrega"
      ),
    },
  };
  state.dataEdi.dataEdiByApelido = action.payload;
};

export const listByFilterReducer = (state, action) => {
  const { nestedList, apelido, tipoDocumento, dataHoraInicial, dataHoraFinal } =
    action.payload;

  state.dataEdiList.data = getDataForList(
    nestedList,
    state.ediGeralFilters.extraNameDoc === "Comprovantes"
      ? "Comprovantes"
      : state.ediGeralFilters.tabAtual,
    tipoDocumento
  );

  state.dataEdiList.filtersCSV = {
    dataHoraInicial: moment(dataHoraInicial).format(DATETIME_FORMAT.API),
    dataHoraFinal: moment(dataHoraFinal).format(DATETIME_FORMAT.API),
    tipoDocumento: tipoDocumento,
    idApelido: apelido,
  };
};
